<template>
  <div class="interval__container row center">
    <div class="interval">{{ t('monthly') }}</div>

    <div
      @click="$emit('updateInterval')"
      :class="['toggle__outer', { active: interval === 'annual' }]"
    >
      <div class="toggle__inner"></div>
    </div>

    <div class="interval">{{ t('annual') }}</div>
  </div>
</template>

<script>
export default {
  name: 'IntervalToggle',
  emits: ['updateInterval'],
  props: {
    interval: { type: String, default: 'monthly' },
  },
}
</script>

<style lang="scss" scoped>
.interval__container {
  .interval {
    width: 100px;

    &:first-of-type {
      text-align: end;
    }
  }
}
.toggle__outer {
  width: 50px;
  height: 26px;
  background-color: var(--arctic);
  cursor: pointer;

  border-radius: 50px;
  margin: 0 10px;
  position: relative;

  .toggle__inner {
    min-height: 18px;
    min-width: 18px;
    border-radius: 50%;
    background-color: white;
    position: absolute;
    left: 4px;
    top: 4px;
    transition: all linear 0.1s;
  }

  &.active {
    background-color: var(--dark-10);

    .toggle__inner {
      left: 27px;
    }
  }
}
</style>
